module.exports = __webpack_public_path__ + "static/media/img7.658542d6.jpg";